import { motion } from "framer-motion";
import styled from "styled-components";
import { setVh } from "../../utils/styles/mixins";
import { mediaMobile } from "../../utils/styles/responsive";

export const Wrapper = styled(motion.div)`
  width: 100%;
  height: ${setVh(100)};
  overflow: hidden;
`;

export const ControllerButtonWrapper = styled(motion.div)`
  position: absolute;
  bottom: 80rem;
  left: 94rem;
  > svg {
    max-width: 130rem;
  }

  .directionLeft,
  .directionTop,
  .directionRight,
  .directionBottom,
  .zoomIn,
  .zoomOut {
    width: 35rem;
    height: 35rem;
    position: absolute;
    left: 50%;
    top: 50%;
    // background: rgba(255, 0, 0, 0.5);
  }
  .directionLeft{
    transform: translateX(-75rem) translateY(-45rem);
  }
  .directionTop{
    transform: translateX(-50%) translateY(-105rem);
  }
  .directionRight{
    transform: translateX(45rem) translateY(-45rem);
  }
  .directionBottom{
    transform: translateX(-50%) translateY(17.5rem);
  }
  .zoomIn{
    transform: translateX(-65rem) translateY(60rem);
  }
  .zoomOut{
    transform: translateX(30rem) translateY(60rem);
  }
  ${mediaMobile(`
    gap: 20rem;
    left: 27rem;
    bottom: 24rem;
    > svg {
      max-width: 80rem;
    }

    .directionLeft,
    .directionTop,
    .directionRight,
    .directionBottom,
    .zoomIn,
    .zoomOut {
      width: 25rem;
      height: 25rem;
    }
      
    .directionLeft{
      transform: translateX(-47.5rem) translateY(-30rem);
    }
    .directionTop{
      transform: translateX(-50%) translateY(-65rem);
    }
    .directionRight{
      transform: translateX(25rem) translateY(-30rem);
    }
    .directionBottom{
      transform: translateX(-50%) translateY(7.5rem);
    }
    .zoomIn{
      transform: translateX(-45rem) translateY(35rem);
    }
    .zoomOut{
      transform: translateX(20rem) translateY(35rem);
    }
  `)};
`;

export const Buttons = styled(motion.div)`
  width: auto;
  height: ${setVh(100)};
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-direction: column;
  padding: 130rem 84rem 80rem 84rem;
  pointer-events: none;

  ${mediaMobile(`
    padding: 36rem 27rem 34rem 27rem;
    height: 100%;
  `)};
`;
export const ButtonsTop = styled.div`
  width: 100%;
  height: auto;
  pointer-events: all;
`;
export const ButtonsBottom = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 33rem;
  pointer-events: all;

  ${mediaMobile(`
    width: calc(100vw - 175rem);
    flex-direction: row-reverse;  
  `)}
`;